<script>
import { RadioGroup } from "bits-ui";
let { value = $bindable(), disabled = false, children, ...restProps } = $props();
</script>
<RadioGroup.Root bind:value {disabled} {...restProps}>
  {@render children?.()}
</RadioGroup.Root>
